import { useTranslation } from 'react-i18next';

export default function OrgCard({ org, onOpen }) {
  const { t } = useTranslation();
  const location = [org.city, org.country].filter(Boolean).join(', ');
  return (
    <button
      type="button"
      onClick={() => onOpen(org)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <div className="flex w-full flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
          {t(`organizations.types.${org.type}`)}
        </span>
        {org.open_access && (
          <span className="rounded-full border border-emerald-500/40 bg-emerald-950/30 px-2 py-0.5 text-[0.65rem] font-medium uppercase tracking-[0.12em] text-emerald-200">
            {t('organizations.detail.openAccess')}
          </span>
        )}
      </div>
      <h3 className="font-serif text-lg font-semibold text-cream">{org.name}</h3>
      {org.publisher && org.type === 'journal' && (
        <p className="text-sm italic text-ink-secondary">{org.publisher}</p>
      )}
      {org.description && (
        <p className="line-clamp-3 text-sm text-ink-secondary">{org.description}</p>
      )}
      {location && (
        <p className="mt-1 text-xs uppercase tracking-[0.12em] text-ink-muted">{location}</p>
      )}
    </button>
  );
}
